import PortalRoleAndAssignmentsBoilerplate from "./roleBoilerplates/PortalRoleAndAssignmentsBoilerplate"
import PortalRoleTempateWithPortalRoleLnksBoilerplate from "./templateBoilerplates/PortalRoleTempateWithPortalRoleLnksBoilerplate"

const stateBoilerplate = {
    view: 0,
    firstLoad: true,
    busyId: -1,
    addOrEditRoleId: -1,
    deleteRoleId: -1,
    addOrEditTemplateId: -1,
    deleteTemplateId: -1,
    searchInput: null,
    rolesAndAssignments: [PortalRoleAndAssignmentsBoilerplate],
    roleTemplates: [PortalRoleTempateWithPortalRoleLnksBoilerplate],
}

export default stateBoilerplate